import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyService } from '@app/_components/property';
import { FeaturesService } from '../features.service';
import { Features } from '../features';
import { SearchTemplateComponent } from '@app/_components/report/search-template/search-template.component';
import { FeatureAdminContainerComponent } from '@app/_components/property/feature/feature-admin-container/feature-admin-container.component';
import { PropertyFeatureTemplateService } from '@app/_components/property/property-feature-template/property-feature-template.service';

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class FeaturesComponent implements OnInit {
    properties: any;
    propertyFeatureTempletes: any;
    propertyFeatures: any;
    showPropertyFeatureTemplate = false;
	describesTypes: any[]=[];

	constructor(
		private propertyFeatureTemplateService: PropertyFeatureTemplateService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private featureService: FeaturesService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.feature = data.feature? data.feature : null,
			this.propertyFeatures = data.propertyFeatures? data.propertyFeatures : null,
			this.showPropertyFeatureTemplate = data.showPropertyFeatureTemplate;
			this.statuses = featureService.statuses;
			this.describesTypes = featureService.describesTypes;
	}

	@Input() feature: Features;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	featureId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'featureId': [],
		/*'shortTermRentalId': [{ type: 'required', message: 'Required' }],
		'propertyCode': [],*/
		'title': [],
		'name': [{ type: 'required', message: 'Required' }],
		'featureType': [],
		'featureLabel': [],
		'defaultFeature': [],
		'defaultHighlight': [],
		'featureDesc': [],
		'quantity': [],
		'describesType': [],
		'kbmMap': [],
		'vrboMap': [],
		'rentalsUnitedMap': [],
		'privateNotes': [],
		airbnbCode: [],
		bookingcomCode: [],
		expediaCode: [],
		googleCode: [],
		marriottCode: [],
		vrboCode: [],
	};

	highlights = [
		{ name: 'None', value: '' },
		{ name: 'Details', value: 1 },
		{ name: 'Details+Summary', value: 2 },
		{ name: 'Details+Summary+Results', value: 3 },
	];

	defaultFeatures = [
		{ name: 'None', value: '' },
		{ name: 'Mandatory', value: 'M' },
		{ name: 'Optional', value: 'O' },
	];

	ngOnInit() {
		this.fetchPropertyFeatureTemplate();
		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole feature object
		if (this.feature) {
			this.featureId = this.feature.featureId;
			this.fixDates();
			this.form1.patchValue(this.feature);
			if (this.form1.value.describesType != undefined && this.form1.value.describesType != null && this.form1.value.describesType != "") {
				// Convert the string to an array of values
				const selectedValues = this.feature.describesType.split(',');

				// Match the values with your describesTypes list
				const selectedObjects = this.describesTypes.filter(type => selectedValues.includes(type.value));

				// Patch the form with the array of objects
				this.form1.patchValue({
					describesType: selectedObjects
				});
			}
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.featureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			const describesTypeData = Array.isArray(this.form1.value.describesType)
				? this.form1.value.describesType
					.map((describesType: any) => describesType?.value)
					.filter((val: string | null | undefined) => !!val)
					.join(',')
				: '';
			this.form1.value.describesType = describesTypeData;
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.featureService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.feature = res.data.feature;
						this.doAdd.emit(this.feature);
					},
					(err: any) => {
						console.log('feature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('feature: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			const describesTypeData = Array.isArray(this.form1.value.describesType)
				? this.form1.value.describesType
					.map((describesType: any) => describesType?.value)
					.filter((val: string | null | undefined) => !!val)
					.join(',')
				: '';
			this.form1.value.describesType = describesTypeData;
			this.formLoading = true;
			if(this.form1.value.describesType != undefined && this.form1.value.describesType != null && this.form1.value.describesType != ""){
				const selectedTypes = this.form1.get('describesType').value;
				const describesTypeString = selectedTypes.map(type => type.value).join(',');
				this.form1.value.describesType = describesTypeString;
			}
			this.featureService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.feature = res.data.feature;
						this.doUpdate.emit(this.feature);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.featureService.delete(this.feature.featureId)
				.subscribe(
					(res: any) => {
						console.log('feature-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.feature);
					},
					(err: any) => {
						console.log('feature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			featureId: [this.featureId],
			/*shortTermRentalId:  ['', Validators.required],
			propertyCode: [],*/
			title: [],
			name: ['', Validators.required],
			featureType: [],
			featureLabel: [],
			defaultFeature: [],
			defaultHighlight: [],
			featureDesc: [],
			quantity: [],
			describesType: [],
			kbmMap: [],
			vrboMap: [],
			rentalsUnitedMap: [],
			privateNotes: [],
			airbnbCode: [],
			bookingcomCode: [],
			expediaCode: [],
			googleCode: [],
			marriottCode: [],
			vrboCode: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.feature.featureDate = moment(this.feature.featureDate).toDate();
	}
	
	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
	
	fetchPropertyFeatureTemplate() {
		if (!this.propertyFeatureTempletes || this.propertyFeatureTempletes === undefined || this.propertyFeatureTempletes.length < 1) {
			try {
				this.propertyFeatureTemplateService.findAll()
					.subscribe(
						res => {
							console.log('findAllpropertyFeatureTemplateSummary: ' + JSON.stringify(res));
							this.propertyFeatureTempletes = res.data.propertyFeatureTemplates;
							return this.propertyFeatureTempletes;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.propertyFeatureTempletes);
		}
	}
	
	/*********
		* Copy To Feature
		*
		*/
	copyToFeature() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			feature: this.feature,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FeatureAdminContainerComponent, dialogConfig);
	}
}
